import React, { useEffect, useRef, useState } from "react";
import { UserCommonStyles } from "../../styles/CommonStyles";
import { useTranslation } from "react-i18next";
import { IAdList } from "../../interfaceModules/IUserInterface";
import { AdListSchema } from "../../utils/validationSchema";
import { yupResolver } from "@hookform/resolvers/yup";
import { isEmpty, calculateDateDifferences } from "../../utils/helper";
import {
  Grid,
  TextField,
  Typography,
  Select,
  MenuItem,
  Button,
  Modal,
} from "@mui/material";
import { Box } from "@mui/system";
import {
  ImgTypeArray,
  Reason,
  Region,
  VideoTypeArray,
  VideoTypes,
  locationPrediction,
} from "../../utils/constants";
import moment from "moment";
import Calendar from "react-calendar";
import { Controller, useForm } from "react-hook-form";
import { toast } from "../../utils/toastsMessage";
import imageCompression from "browser-image-compression";
import { GooglePlacesDetail } from "../../redux/action-creators/profileAction";
import { useDispatch } from "react-redux";
import Dropzone from "react-dropzone";
import { HighlightOff, Preview } from "@mui/icons-material";
import { CommonButton } from "../../stories/Button";
import ClipLoader from "react-spinners/ClipLoader";

const style = {
  position: "absolute" as "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "#fff",
  // border: "2px solid #000",
  p: 4,
};

const CreateAdStep1: React.FC<any> = (props: any) => {
  const {
    isEdit,
    setFormHandler,
    adCenterStep1Data,
    setAdCenterStep1DAta,
    adStartDate,
    setAdStartDate,
    adEndDate,
    setAdEndDate,
    locationPredictions,
    setLocationPredictions,
    files,
    setFile,
    uploadedFiles,
    days,
    setDays,
    isRunningAd,
    currentDate,
    setUploadedFiles,
    cancelProduct,
  } = props;
  const commonStyle = UserCommonStyles();
  const { t: translation } = useTranslation();
  const dispatch = useDispatch();

  const tomorrowDate = new Date(); // Clone the current date to avoid modifying it directly
  tomorrowDate.setDate(new Date().getDate() + 1);

  const [imageError, setimageError] = useState("");
  const [disable, setDisable] = React.useState(false);
  const [timeOutState, setTimeOutState] = useState(null);
  const [startDateError, setStartDateError] = useState("");
  const [endDateError, setEndDateError] = useState("");
  const [loactionerr, setlocationerr] = useState(false);
  const [modal, setModal] = useState<any>({
    isShow: false,
    data: {},
    message: "",
  });
  const wrapperRef = useRef(null);
  useOutsideAlerter(wrapperRef);

  function useOutsideAlerter(ref) {
    useEffect(() => {
      /**
       * Alert if clicked on outside of element
       */
      function handleClickOutside(event) {
        if (ref.current && !ref.current.contains(event.target)) {
          setLocationPredictions((prevState) => ({
            ...prevState,
            predictions: [],
          }));
        }
      }

      /**
       * Bind the event listener
       */
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        /**
         * Unbind the event listener on clean up
         */
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useEffect(() => {
    setDays((prev: any) => ({
      ...prev,
      current:
        calculateDateDifferences(adStartDate?.current, adEndDate?.current) + 1,
    }));
  }, [adStartDate, adEndDate]);

  /**
   * To Remove selected images from Drag & Drop list
   * @param index
   */
  const removeImage = (index: number) => {
    const remove = [...files];
    remove.splice(index, 1);

    setFile(remove);
    setUploadedFiles(remove);
  };

  const {
    handleSubmit,
    reset,
    register,
    control,
    formState: { errors },
  } = useForm<IAdList>({
    resolver: yupResolver(AdListSchema(translation)),
    defaultValues: {
      company_name: adCenterStep1Data.company_name || "",
      company_website_url: adCenterStep1Data.company_website_url || "",
      email: adCenterStep1Data.email || "",
      location: adCenterStep1Data.location || "",
      phone_number: adCenterStep1Data.phone_number || "",
      reason: adCenterStep1Data.reason || "",
      region: adCenterStep1Data.region || "",
    },
  });

  /**
   * Autocomplete search
   * @param text
   * @returns
   */
  const googleAutocomplete = async (text: string) => {
    if (isEmpty(text)) {
      setLocationPredictions((prevState) => ({
        ...prevState,
        predictions: [],
      }));
      return null;
    }
    if (!text) {
      return translation("valid_text");
    }
    if (typeof window === "undefined") {
      return translation("valid_window");
    }

    try {
      let result;
      let autocompleteService =
        await new google.maps.places.AutocompleteService();
      result = await autocompleteService.getPlacePredictions(
        { input: text },
        result
      );
      return result;
    } catch (e) {
      return e;
    }
  };

  /**
   * Select location
   * @param event
   */
  const selectLocation = async (event?: React.SyntheticEvent | Event) => {
    const target = event.target as HTMLInputElement;
    setLocationPredictions((prevState) => ({
      ...prevState,
      location: target.value,
    }));
    if (timeOutState) {
      clearInterval(timeOutState);
    }

    let result = setTimeout(async () => {
      let results = await googleAutocomplete(target.value);
      if (results) {
        setLocationPredictions((prevState) => ({
          ...prevState,
          latitude: 0,
          longitude: 0,
          predictions: results?.predictions,
        }));
      }
    }, 800);

    setTimeOutState(result);
  };

  /**
   * on Place selected by placeId
   * @param placeId
   * @param placeDescription
   * @param event
   * @returns
   */
  const onPlaceSelected = async (
    placeId: string,
    placeDescription: string,
    event: React.SyntheticEvent
  ) => {
    setlocationerr(false);

    event.preventDefault();
    const response: any = await dispatch(GooglePlacesDetail(placeId));
    if (!response || !response.result) {
      return;
    }
    setLocationPredictions({
      predictions: [],
      location: placeDescription,
      latitude: response.result?.geometry?.location?.lat,
      longitude: response.result?.geometry?.location?.lng,
    });
  };

  const calculateDateDifference = (date1: any, date2: any) => {
    const td = moment(date1).format("YYYY-MM-DD");
    const previousDate = moment(date2).format("YYYY-MM-DD");

    const getDaysDiff = (start_date, end_date, date_format = "YYYY-MM-DD") => {
      const getDateAsArray = (date) => {
        return moment(date.split(/\D+/), date_format);
      };
      return getDateAsArray(end_date).diff(getDateAsArray(start_date), "days");
    };
    return getDaysDiff(td, previousDate);
  };

  const handleStartDateChange = (e: any, is_edit: boolean) => {
    if (is_edit) {
      if (isRunningAd?.isRunning) {
        setStartDateError(
          "You cannot change the start date because the ad is already running."
        );
      } else if (!isRunningAd?.isRunning) {
        const value = moment(e).format("yyyy-MM-DD");
        setAdStartDate((prev: any) => ({
          ...prev,
          current: value,
        }));
      }
    } else {
      const value = moment(e).format("yyyy-MM-DD");
      setAdStartDate((prev: any) => ({
        ...prev,
        current: value,
      }));
    }
  };

  const handleEndDateChange = (e: any, is_edit: boolean) => {
    const value = moment(e).format("yyyy-MM-DD");
    setAdEndDate((prev: any) => ({
      ...prev,
      current: value,
    }));
  };

  /**
   * To handle selcted files (Image And Video)
   * @param file
   */
  const handleSelectFiles = async (file: any) => {
    const imageTypes = ImgTypeArray;
    const videoTypes = VideoTypes;
    if (file.length > 0) {
      for (let i = 0; i < file.length; i++) {
        if (file[i].size > 41943040) {
          return toast.error(translation("file_size_err20"));
        } else {
          const extension = file[i].type.split("/")[1];
          const fileType = file[i].type.split("/")[0];
          if (extension !== undefined) {
            const imgOrVideo = file[i];

            if (imageTypes.includes(extension.toLowerCase())) {
              try {
                const options = {
                  maxSizeMB: 1,
                  maxWidthOrHeight: 720,
                  useWebWorker: true,
                };
                const compressImg = await imageCompression(imgOrVideo, options);
                readFile(compressImg);
              } catch (error) {
                console.log(`Error ==> ${error}`);
              }
            } else if (videoTypes.includes(extension)) {
              readFile(imgOrVideo);
            } else {
              if (
                fileType === "image" &&
                !imageTypes.includes(extension.toLowerCase())
              ) {
                toast.error(translation("file_not_support_img"));
              } else if (
                fileType === "video" &&
                !videoTypes.includes(extension.toLowerCase())
              ) {
                toast.error(translation("file_not_support_video"));
              }
            }
          }
        }
      }
    }
  };

  /**
   * To Read Selected file in base 64
   * @param file
   */
  const readFile = async (file: Blob) => {
    const fileReader = new FileReader();

    fileReader.onloadend = function () {
      setUploadedFiles([]);
      setFile([]);
      if (files.length > 0) {
        setFile((prevState: string[]) => [...prevState, fileReader.result]);
      } else {
        setFile((prevState: string[]) => [...prevState, fileReader.result]);
      }
    };

    fileReader.readAsDataURL(file);
  };

  const validateDateOfBirth = (type: string) => {
    let isFormValid = true;
    setStartDateError("");
    if (type === "start_date") {
      if (adStartDate?.current.length === 0) {
        isFormValid = false;
        setStartDateError("Start date is required");
        setDisable(false);
      } else {
        setStartDateError("");
      }
      return isFormValid;
    } else if (type === "end_date") {
      if (adEndDate.current.length === 0) {
        isFormValid = false;
        setEndDateError("End date is required");
        setDisable(false);
      } else {
        setEndDateError("");
      }
      return isFormValid;
    }
  };

  const matchDays = () => {
    const startDate = moment(adStartDate?.current);
    const endDate = moment(adEndDate?.current);
    return endDate.diff(startDate, "days") + 1 < days?.previous;
  };

  const step1FormHandler = (data: any) => {
    if (adStartDate?.current.length === 0) {
      setStartDateError("Start date is required");
      window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
    } else {
      setStartDateError("");
    }
    if (adEndDate.current.length === 0) {
      setEndDateError("End date is required");
      window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
    } else if (
      !moment(adEndDate.current).isSameOrAfter(moment(adStartDate.current))
    ) {
      setEndDateError("End date is invalid and is before the start date.");
      window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
    } else {
      setEndDateError("");
    }
    if (locationPredictions.latitude === 0) {
      setlocationerr(true);
      window.scrollTo({ top: 500, left: 0, behavior: "smooth" });
    } else {
      setlocationerr(false);
    }
    if (files.length === 0 && uploadedFiles.length === 0) {
      setimageError(translation("img_req"));
    } else {
      setimageError("");
    }

    if (
      (files.length > 0 || uploadedFiles.length > 0) &&
      locationPredictions.latitude !== 0 &&
      adStartDate?.current.length !== 0 &&
      adEndDate.current.length !== 0 &&
      moment(adEndDate.current).isSameOrAfter(moment(adStartDate.current))
    ) {
      if (isEdit && matchDays()) {
        setModal({
          isShow: true,
          data: data,
          message: `You are reducing the days for your ad, previous days is ${
            days?.previous || ""
          } and currently days is ${
            days?.current || ""
          } for ad. Are you sure you want to continue?`,
        });
        // setEndDateError(`You are reducing the days for your ad. Previous days is ${days?.previous || ""} and currently days is ${days?.current || ""} for ad, please extend your days.`);
        //  return window.scrollTo({ top: 200, left: 0, behavior: "smooth" });
      } else {
        setAdCenterStep1DAta(data);
        const dataa = {
          data,
          adStartDate: adStartDate?.current,
          adEndDate: adEndDate?.current,
          locationPredictions,
          files: files,
        };
        // console.log("dataa", dataa);
        setFormHandler({
          isShowStep1: false,
          isShowStep2: true,
          isShowStep3: false,
          isShowStep4: false,
        });
      }
    }
  };

  const continueByModal = () => {
    setAdCenterStep1DAta(modal?.data);
    const dataa = {
      data: modal?.data,
      adStartDate: adStartDate,
      adEndDate: adEndDate,
      locationPredictions,
      files: files,
    };
    setFormHandler({
      isShowStep1: false,
      isShowStep2: true,
      isShowStep3: false,
      isShowStep4: false,
    });
    setModal({ isShow: false, data: {}, message: "" });
  };

  return (
    <Box className={`${commonStyle.p20} ${commonStyle.card}`}>
      <form onSubmit={handleSubmit(step1FormHandler)}>
        <Grid container spacing={2}>
          <Grid item md={6}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("company_name")}
              </Typography>
              <TextField
                {...register("company_name")}
                className={commonStyle.w100}
                // onChange={(e) => handleChangetextfield(e, "company_name")}
                // value={adCenterStep1Data?.company_name}
              />
              {errors && errors?.company_name && (
                <span className={commonStyle.errorMsg}>
                  {errors?.company_name?.message}
                </span>
              )}
            </Box>
          </Grid>

          <Grid item md={6}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("company_url")}
              </Typography>
              <TextField
                {...register("company_website_url")}
                variant="outlined"
                className={commonStyle.w100}
                // onChange={(e) => handleChangetextfield(e, "company_website_url")}
                // value={adCenterStep1Data?.company_website_url}
              />
              {errors && errors?.company_website_url && (
                <span className={commonStyle.errorMsg}>
                  {errors?.company_website_url?.message}
                </span>
              )}
            </Box>
          </Grid>
          <Grid item md={6}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("email")}
              </Typography>
              <TextField
                {...register("email")}
                variant="outlined"
                className={commonStyle.w100}
                // onChange={(e) => handleChangetextfield(e, "email")}
                // value={adCenterStep1Data?.email}
              />
              {errors && errors.email && (
                <span className={commonStyle.errorMsg}>
                  {errors?.email?.message}
                </span>
              )}
            </Box>
          </Grid>

          <Grid item md={6}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("contact")}
              </Typography>
              <TextField
                {...register("phone_number")}
                variant="outlined"
                className={commonStyle.w100}
                // onChange={(e) => handleChangetextfield(e, "phone_number")}
                // value={adCenterStep1Data?.phone_number}
              />
              {errors && errors.phone_number && (
                <span className={commonStyle.errorMsg}>
                  {errors?.phone_number?.message}
                </span>
              )}
            </Box>
          </Grid>
          <Grid item lg={6} md={6} sm={12}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("start_date")}
              </Typography>
              {isEdit ? (
                <Calendar
                  style={{ height: 500 }}
                  onChange={(event: any) =>
                    handleStartDateChange(event, isEdit)
                  }
                  value={
                    adStartDate?.current !== "" &&
                    moment(adStartDate?.current).toDate()
                  }
                  minDate={
                    isRunningAd?.isRunning
                      ? new Date(adStartDate?.current)
                      : tomorrowDate
                  }
                  // minDate={
                  //   calculateDateDifferences(
                  //     currentDate,
                  //     adStartDate?.previous
                  //   ) < 1
                  //     ? new Date(adStartDate?.current)
                  //     : tomorrowDate
                  // }
                ></Calendar>
              ) : (
                <Calendar
                  style={{ height: 500 }}
                  onChange={(event: any) =>
                    handleStartDateChange(event, isEdit)
                  }
                  value={
                    adStartDate?.current !== "" &&
                    moment(adStartDate?.current).toDate()
                  }
                  minDate={tomorrowDate}
                ></Calendar>
              )}
              {startDateError && startDateError.length > 0 && (
                <span className={commonStyle.errorMsg}>{startDateError}</span>
              )}
            </Box>
          </Grid>

          <Grid item lg={6} md={6} sm={12}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {"End Date"}
              </Typography>
              {isEdit ? (
                <Calendar
                  style={{ height: 500 }}
                  onChange={(event: any) => handleEndDateChange(event, isEdit)}
                  value={
                    adEndDate.current !== "" &&
                    moment(adEndDate?.current).toDate()
                  }
                  minDate={isRunningAd?.isRunning ? currentDate : tomorrowDate}
                ></Calendar>
              ) : (
                <Calendar
                  style={{ height: 500 }}
                  onChange={(event: any) => handleEndDateChange(event, isEdit)}
                  value={
                    adEndDate.current !== "" &&
                    moment(adEndDate?.current).toDate()
                  }
                  minDate={tomorrowDate}
                ></Calendar>
              )}

              {endDateError && endDateError.length > 0 && (
                <span className={commonStyle.errorMsg}>{endDateError}</span>
              )}
            </Box>
          </Grid>

          <Grid item md={12}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("region")}
              </Typography>
              <Controller
                name="region"
                control={control}
                defaultValue={adCenterStep1Data.region}
                render={({ field }) => {
                  return (
                    <Select
                      value={
                        field.value ? field.value : adCenterStep1Data.region
                      }
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      {...register("region")}
                      className={commonStyle.w100}
                    >
                      {Region.length > 0 &&
                        Region?.map((region, index) => {
                          return (
                            <MenuItem key={index} value={translation(region)}>
                              {translation(region)}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  );
                }}
              />
              {errors && errors.region && (
                <span className={commonStyle.errorMsg}>
                  {errors?.region?.message}
                </span>
              )}
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("ad_reason")}{" "}
              </Typography>
              <Controller
                name="reason"
                control={control}
                defaultValue={adCenterStep1Data.reason}
                render={({ field }) => {
                  return (
                    <Select
                      value={
                        field.value ? field.value : adCenterStep1Data.reason
                      }
                      onChange={(e) => {
                        field.onChange(e);
                      }}
                      {...register("reason")}
                      className={commonStyle.w100}
                    >
                      {Reason.length > 0 &&
                        Reason?.map((reason, index) => {
                          return (
                            <MenuItem
                              key={index}
                              // value={translation(reason)}
                              value={reason}
                            >
                              {reason}
                            </MenuItem>
                          );
                        })}
                    </Select>
                  );
                }}
              />
              {errors && errors.reason && (
                <span className={commonStyle.errorMsg}>
                  {errors?.reason?.message}
                </span>
              )}
            </Box>
          </Grid>

          <Grid item md={12}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("location")}
              </Typography>
              <TextField
                {...register("location")}
                variant="outlined"
                className={commonStyle.w100}
                autoComplete="off"
                onChange={selectLocation}
                value={locationPredictions.location}
              />

              {locationPredictions.predictions.length !== 0 && (
                <div className="search-drop-list" ref={wrapperRef}>
                  <ul className={commonStyle.searchCommonList}>
                    {locationPredictions.predictions.map((prediction) => (
                      <li
                        key={prediction?.place_id}
                        onClick={(e) =>
                          onPlaceSelected(
                            prediction?.place_id,
                            prediction?.description,
                            e
                          )
                        }
                      >
                        {prediction?.description || translation("not_found")}
                      </li>
                    ))}
                  </ul>
                </div>
              )}
              {!locationPredictions.location ? (
                <span className={commonStyle.errorMsg}>
                  {errors?.location?.message}
                </span>
              ) : loactionerr ? (
                <span className={commonStyle.errorMsg}>
                  {"Please select a valid location"}
                </span>
              ) : (
                ""
              )}
            </Box>
          </Grid>
          <Grid item md={12}>
            <Box className={commonStyle.commonInput}>
              <Typography className={commonStyle.labelCommonInput}>
                {translation("upload_image")}
              </Typography>
              <Box className={`${commonStyle.commonUploadBox}`}>
                <Dropzone
                  onDrop={(files) => handleSelectFiles(files)}
                  maxFiles={1}
                  // accept="image/*"
                  accept="image/*, video/*"
                >
                  {({ getRootProps, getInputProps }) => (
                    <div className="container">
                      <div {...getRootProps({ className: "dropzone" })}>
                        <p>{translation("drop_box_content")}</p>
                        <input {...getInputProps()} />
                      </div>

                      {uploadedFiles.length > 0 ? (
                        <ul
                          className={`${commonStyle.flexCenter} ${commonStyle.justifyCenter} ${commonStyle.removeListStyle} ${commonStyle.dragList}`}
                        >
                          {uploadedFiles.length > 0 &&
                            uploadedFiles.map((item: string, index: number) => {
                              let type = ""; // item.split("-")[2].split(".")[0];
                              if (item.indexOf("adVideo") !== -1) {
                                type = "video";
                              } else {
                                type = "image";
                              }
                              return (
                                <li key={index}>
                                  {type === "image" ? (
                                    <img
                                      src={item}
                                      alt="null"
                                      className={commonStyle.imageDragDrop}
                                    />
                                  ) : type === "video" ? (
                                    <video
                                      controls
                                      src={item}
                                      className={commonStyle.imageDragDrop}
                                    />
                                  ) : null}
                                  <HighlightOff
                                    onClick={() => removeImage(index)}
                                  />
                                </li>
                              );
                            })}
                        </ul>
                      ) : null}

                      {files.length > 0 ? (
                        <ul
                          className={`${commonStyle.flexCenter} ${commonStyle.justifyCenter} ${commonStyle.removeListStyle} ${commonStyle.dragList}`}
                        >
                          {files.length > 0 &&
                            files.map((item, index) => {
                              let type = item.split("/")[0].split(":")[1];
                              return (
                                <li key={index}>
                                  {type === "image" ? (
                                    <img
                                      src={item}
                                      alt="null"
                                      className={commonStyle.imageDragDrop}
                                    />
                                  ) : type === "video" ? (
                                    <video
                                      controls
                                      src={item}
                                      className={commonStyle.imageDragDrop}
                                    />
                                  ) : null}
                                  <HighlightOff
                                    onClick={() => removeImage(index)}
                                  />
                                </li>
                              );
                            })}
                        </ul>
                      ) : null}
                    </div>
                  )}
                </Dropzone>
              </Box>
              {files.length === 0 && (
                <span className={commonStyle.errorMsg}>{imageError}</span>
              )}
            </Box>
          </Grid>
        </Grid>
        <Box className={commonStyle.flexCenter}>
          <Box className={`${commonStyle.mr10} ${commonStyle.blueBtn}`}>
            <Button disabled={disable} onClick={handleSubmit(step1FormHandler)}>
              {translation("save&continue")} {disable ? <ClipLoader /> : null}
            </Button>
          </Box>
          <Box className={`${commonStyle.mr10} ${commonStyle.greyBtn}`}>
            <CommonButton
              onClick={cancelProduct}
              label={translation("cancel")}
            />
          </Box>
        </Box>
      </form>
      <Modal
        open={modal?.isShow}
        onClose={() => setModal({ isShow: false, data: {}, message: "" })}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        // className={styleClasses.modalShadow}
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" component="h2">
            {modal?.message ? modal?.message : ""}
          </Typography>
          <Box
            id="modal-modal-description"
            sx={{ mt: 2 }}
            className={commonStyle.flexCenter}
          >
            <Box
              className={`${commonStyle.blueBtn} ${commonStyle.pt20} ${commonStyle.mr10}`}
            >
              <Button onClick={continueByModal}>
                {"Yes"}
                {disable ? <ClipLoader /> : null}
              </Button>
            </Box>

            <Box className={`${commonStyle.blueBtn} ${commonStyle.pt20}`}>
              <Button
                onClick={() => {
                  setModal({ isShow: false, data: {}, message: "" });
                }}
              >
                {"No"}
              </Button>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
};

export default CreateAdStep1;
